import { useState } from 'react';

import { type CategoryNode } from '../../category-tree';
import { type SubjectFormValues } from '../types';

export const useSelectSubSubjectNode = ({
  selectedSubjectNode,
  subjectFormValues,
}: {
  selectedSubjectNode?: CategoryNode;
  subjectFormValues: SubjectFormValues;
}) => {
  const [selectedSubSubjectNode, setSelectedSubSubjectNode] = useState<
    CategoryNode | undefined
  >(
    () =>
      selectedSubjectNode?.subNodes.find(
        node => node.nodeId === subjectFormValues.subSubject,
      ),
  );

  return [selectedSubSubjectNode, setSelectedSubSubjectNode] as const;
};
